import { useMutation } from "@tanstack/react-query";

import { GuestPass } from "@/components/GuestPasses";
import { createGuestPassShareLink } from "@/services/finance";
import { fetchJSONFactory } from "@/utils/fetch-json";

const fetchJSON = fetchJSONFactory(import.meta.env.VITE_FINANCE_API);

export type GetGuestPassesResponse = GuestPass[];

export type ShareGuestPassResponse = {
  sucId: string;
};

type ShareGuestPassViaSmsParams = {
  firstName: string;
  lastName: string;
  phone: string;
  parentCouponCodeId: number;
};

export function shareViaSms({
  firstName: firstName,
  lastName: lastName,
  phone,
  parentCouponCodeId,
}: ShareGuestPassViaSmsParams) {
  return fetchJSON<ShareGuestPassResponse>("/users/send-guest-pass", {
    body: {
      firstName,
      lastName,
      parentCouponCodeId,
      channel: {
        type: "sms",
        sms: phone,
      },
    },
    method: "POST",
  });
}

export const useShareGuestPassViaSmsMutation = () => {
  return useMutation({
    mutationFn: shareViaSms,
  });
};

type ShareGuestPassViaEmailParams = {
  firstName: string;
  lastName: string;
  email?: string;
  parentCouponCodeId: number;
};

export function shareViaEmail({
  firstName,
  lastName,
  email,
  parentCouponCodeId,
}: ShareGuestPassViaEmailParams) {
  return fetchJSON<ShareGuestPassResponse>("/users/send-guest-pass", {
    body: {
      firstName,
      lastName,
      parentCouponCodeId,
      channel: {
        type: "email",
        email,
      },
    },
    method: "POST",
  });
}

export const useShareGuestPassViaEmailMutation = () => {
  return useMutation({
    mutationFn: shareViaEmail,
  });
};

export const useCreateGuestPassShareLink = () => {
  return useMutation({
    mutationFn: createGuestPassShareLink,
  });
};
